export default __webpack_public_path__ + "static/jindra-27ce7a054090bd9fa6554600538ef1d4.jpg";